import { useEffect } from 'react'
import { Paper, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { shallowEqual, useSelector } from 'react-redux'
import { reportsSelector } from '@/state/reports/slices/index.slices'
import NoContentAvailable from '@/views/components/no-content-available/index.component'

import UiFeedbackComponent from './components/ui-feedback/index.component'
import GlobalReportsTable from './components/table-global/index.component'
import RoundsReportsTable from './components/table-rounds/index.component'

import ReportsFilters from './components/filters/index.component'
import useReportsActions from './hooks/use-reports-actions.hooks'
import useReportsFilters from './hooks/use-reports-filters.hooks'

import useWalletReportDrawer from './hooks/use-wallets-report-drawer.hook'

const ReportsModule = () => {
  const { t } = useTranslation()

  const { toggleDrawer } = useWalletReportDrawer()

  const { roundsReports, globalReports } = useSelector(
    reportsSelector,
    shallowEqual,
  )

  const { setReportsFilters, resetRoundsReports, resetGlobalReports } =
    useReportsActions()

  const { filters } = useReportsFilters()

  useEffect(() => {
    return () => {
      setReportsFilters({
        reportType: '',
        transactionsDateRange: '',
        page: 1,
        limit: 10,
      })
      resetGlobalReports()
      resetRoundsReports()
      toggleDrawer(false)
    }
  }, []) // eslint-disable-line

  return (
    <>
      <Box component={Paper} p={2} display="flex" flexDirection="column">
        <ReportsFilters />
        {filters.reportType !== '1' &&
        globalReports !== undefined &&
        globalReports.length > 0 ? (
          <GlobalReportsTable />
        ) : filters.reportType === '1' &&
          roundsReports !== undefined &&
          roundsReports.length > 0 ? (
          <RoundsReportsTable />
        ) : (
          <Box border="1px solid">
            <NoContentAvailable
              title={t('messages.noData')}
              instruction={t('messages.noResultsFound')}
            />
          </Box>
        )}
        <UiFeedbackComponent />
      </Box>
    </>
  )
}

export default ReportsModule
